"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cmsCtaBannerSchema = exports.cmsAboutSchema = exports.cmsHeroSchema = exports.cmsValueSchema = exports.cmsTimelineEntrySchema = exports.cmsServiceSchema = exports.cmsTestimonialSchema = exports.cmsFeatureSchema = exports.cmsStatSchema = exports.cmsLinkSchema = exports.cmsSectionIds = exports.fleetSettingsSchema = exports.routingSettingsSchema = exports.favouritePoiSchema = exports.aiSettingsSchema = exports.blogDefaultsSchema = exports.blogDefaultKeywordSchema = exports.contactSettingsSchema = exports.contactRecipientSchema = exports.analyticsSettingsSchema = exports.seoSettingsSchema = exports.seoPageDefaultsSchema = exports.seoSocialSchema = exports.seoTagDefaultsSchema = exports.emailSettingsSchema = exports.emailRoutingPolicySchema = exports.emailNotificationChannelSchema = exports.emailTemplateSchema = exports.emailProviderSchema = exports.aiProviderConfigSchema = exports.aiProviderModelSchema = exports.aiModelStatusSchema = exports.aiCapabilitySchema = exports.videoSettingsV1Schema = exports.ubiSettingsSchema = exports.ubiThresholdsSchema = exports.ubiPartnerSchema = exports.ubiConsentPolicySchema = exports.walletSettingsSchema = exports.mapSettingsSchema = exports.mapAiSchema = exports.mapSpatialSchema = exports.mapLayersSchema = exports.assetDisplayModeSchema = exports.vehicleIconSetSchema = exports.mapThemeSchema = exports.mapProviderSchema = exports.updateSettingsSchema = exports.settingsScopeSchema = exports.settingsScopes = void 0;
exports.aiProviderCatalogSchema = exports.cmsSettingsSchema = exports.cmsShowcaseSchema = exports.cmsFooterSchema = void 0;
const zod_1 = require("zod");
exports.settingsScopes = [
    "org",
    "users",
    "devices",
    "maps",
    "rules",
    "billing",
    "integrations",
    "privacy",
    "ai",
    "video",
    "email",
    "cms",
    "ubi",
    "wallet",
    "developer",
    "seo",
    "analytics",
    "contact",
    "blog",
    "fleet",
    "routing",
];
exports.settingsScopeSchema = zod_1.z.enum(exports.settingsScopes);
exports.updateSettingsSchema = zod_1.z
    .object({
    changes: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
})
    .strict();
// "mapbox" and "here" are retired engines kept only so previously persisted
// tenant settings still parse; clients coerce them to "google" on read.
exports.mapProviderSchema = zod_1.z.enum(["google", "mapbox", "here"]);
exports.mapThemeSchema = zod_1.z.enum(["standard", "satellite", "dark", "terrain"]);
exports.vehicleIconSetSchema = zod_1.z.enum(["smartFleet", "mixedFleet", "specialized"]);
exports.assetDisplayModeSchema = zod_1.z.enum(["standard", "farmers", "both"]);
exports.mapLayersSchema = zod_1.z
    .object({
    traffic: zod_1.z.boolean().default(true),
    heatmap: zod_1.z.boolean().default(true),
    geofences: zod_1.z.boolean().default(true),
    cameras: zod_1.z.boolean().default(true),
    incidents: zod_1.z.boolean().default(true),
})
    .strict();
exports.mapSpatialSchema = zod_1.z
    .object({
    clusters: zod_1.z.boolean().default(true),
    isoLines: zod_1.z.boolean().default(false),
    polygons: zod_1.z.boolean().default(true),
    routeSnapping: zod_1.z.boolean().default(true),
})
    .strict();
exports.mapAiSchema = zod_1.z
    .object({
    predictiveRouting: zod_1.z.boolean().default(true),
    anomalyDetection: zod_1.z.boolean().default(true),
    cameraSync: zod_1.z.boolean().default(true),
})
    .strict();
exports.mapSettingsSchema = zod_1.z
    .object({
    provider: exports.mapProviderSchema.default("google"),
    theme: exports.mapThemeSchema.default("standard"),
    layers: exports.mapLayersSchema.default({
        traffic: true,
        heatmap: true,
        geofences: true,
        cameras: true,
        incidents: true,
    }),
    spatial: exports.mapSpatialSchema.default({
        clusters: true,
        isoLines: false,
        polygons: true,
        routeSnapping: true,
    }),
    ai: exports.mapAiSchema.default({
        predictiveRouting: true,
        anomalyDetection: true,
        cameraSync: true,
    }),
    iconSet: exports.vehicleIconSetSchema.default("smartFleet"),
    assetDisplayMode: exports.assetDisplayModeSchema.default("standard"),
    apiKey: zod_1.z.string().trim().min(1).optional(),
    mapId: zod_1.z.string().trim().optional(),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.walletSettingsSchema = zod_1.z
    .object({
    defaultCurrency: zod_1.z.string().length(3).default("USD"),
    reconciliationCadence: zod_1.z.enum(["daily_05_00", "weekly_monday", "monthly_1st"]).default("daily_05_00"),
    payoutAutomation: zod_1.z.enum(["manual", "auto_under_2000", "auto_all"]).default("auto_under_2000"),
    notificationEmails: zod_1.z.array(zod_1.z.string().email()).default([]),
    pendingCreditNotes: zod_1.z.number().int().nonnegative().default(0),
    trialBalance: zod_1.z
        .object({
        amount: zod_1.z.number().nonnegative(),
        currency: zod_1.z.string().length(3),
    })
        .nullable()
        .default(null),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.ubiConsentPolicySchema = zod_1.z.enum([
    "digital_signature",
    "paper",
    "verbal",
]);
exports.ubiPartnerSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    status: zod_1.z.enum(["sandbox", "live", "disabled"]).default("sandbox"),
    contactEmail: zod_1.z.string().email().nullable().optional(),
    phone: zod_1.z.string().nullable().optional(),
    territories: zod_1.z.array(zod_1.z.string()).default([]),
    features: zod_1.z.array(zod_1.z.string()).default([]),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
})
    .strict();
exports.ubiThresholdsSchema = zod_1.z
    .object({
    highRisk: zod_1.z.number().min(0).max(1).default(0.75),
    mediumRisk: zod_1.z.number().min(0).max(1).default(0.45),
})
    .strict();
exports.ubiSettingsSchema = zod_1.z
    .object({
    window: zod_1.z.enum(["7d", "28d", "90d"]).default("28d"),
    consentPolicy: exports.ubiConsentPolicySchema.default("digital_signature"),
    feedCadence: zod_1.z.string().min(1).default("daily_02_00"),
    thresholds: exports.ubiThresholdsSchema.default({ highRisk: 0.75, mediumRisk: 0.45 }),
    partners: zod_1.z.array(exports.ubiPartnerSchema).default([]),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.videoSettingsV1Schema = zod_1.z
    .object({
    general: zod_1.z
        .object({
        enabled: zod_1.z.boolean().default(true),
        defaultView: zod_1.z.enum(["LL_HLS", "WEBRTC"]).default("LL_HLS"),
        timeSync: zod_1.z.enum(["NTP_GPS", "NTP_ONLY"]).default("NTP_GPS"),
    })
        .default({
        enabled: true,
        defaultView: "LL_HLS",
        timeSync: "NTP_GPS",
    }),
    live: zod_1.z
        .object({
        preferredIngest: zod_1.z
            .enum(["SRT", "RTSP", "RTMP", "WEBRTC"])
            .default("SRT"),
        maxLatencyMs: zod_1.z
            .number()
            .int()
            .min(500)
            .max(15000)
            .default(3000),
        bitrateLadderKbps: zod_1.z
            .array(zod_1.z.number().int().positive())
            .min(2)
            .max(6)
            .default([3000, 1500, 800, 400]),
        audioEnabled: zod_1.z.boolean().default(false),
        audioRoles: zod_1.z
            .array(zod_1.z.enum(["ADMIN", "OPS", "INVESTIGATOR", "VIEWER", "PRIVACY"]))
            .default(["INVESTIGATOR"]),
    })
        .default({
        preferredIngest: "SRT",
        maxLatencyMs: 3000,
        bitrateLadderKbps: [3000, 1500, 800, 400],
        audioEnabled: false,
        audioRoles: ["INVESTIGATOR"],
    }),
    recording: zod_1.z
        .object({
        mode: zod_1.z
            .enum(["EVENT_ONLY", "CONTINUOUS", "SCHEDULED"])
            .default("EVENT_ONLY"),
        preBufferSec: zod_1.z
            .number()
            .int()
            .min(0)
            .max(60)
            .default(10),
        postBufferSec: zod_1.z
            .number()
            .int()
            .min(0)
            .max(60)
            .default(20),
        schedule: zod_1.z
            .object({
            timezone: zod_1.z.string().default("UTC"),
            windows: zod_1.z
                .array(zod_1.z
                .object({
                day: zod_1.z.enum([
                    "MON",
                    "TUE",
                    "WED",
                    "THU",
                    "FRI",
                    "SAT",
                    "SUN",
                ]),
                start: zod_1.z.string().regex(/^\d{2}:\d{2}$/),
                end: zod_1.z.string().regex(/^\d{2}:\d{2}$/),
            })
                .strict())
                .default([]),
        })
            .default({
            timezone: "UTC",
            windows: [],
        }),
        provider: zod_1.z.enum(["S3", "AZURE_BLOB"]).default("S3"),
        hotRetentionDays: zod_1.z
            .number()
            .int()
            .min(1)
            .max(365)
            .default(14),
        archivePolicy: zod_1.z
            .object({
            moveToIAAfterDays: zod_1.z
                .number()
                .int()
                .min(0)
                .max(365)
                .default(14),
            moveToArchiveAfterDays: zod_1.z
                .number()
                .int()
                .min(0)
                .max(1095)
                .default(60),
        })
            .default({
            moveToIAAfterDays: 14,
            moveToArchiveAfterDays: 60,
        }),
        cdnEnabled: zod_1.z.boolean().default(true),
        signedUrlTtlMinutes: zod_1.z
            .number()
            .int()
            .min(1)
            .max(1440)
            .default(15),
    })
        .default({
        mode: "EVENT_ONLY",
        preBufferSec: 10,
        postBufferSec: 20,
        schedule: {
            timezone: "UTC",
            windows: [],
        },
        provider: "S3",
        hotRetentionDays: 14,
        archivePolicy: {
            moveToIAAfterDays: 14,
            moveToArchiveAfterDays: 60,
        },
        cdnEnabled: true,
        signedUrlTtlMinutes: 15,
    }),
    ai: zod_1.z
        .object({
        adas: zod_1.z
            .object({
            threshold: zod_1.z.enum(["LOW", "MED", "HIGH"]).default("MED"),
            enabled: zod_1.z.boolean().default(true),
        })
            .default({ threshold: "MED", enabled: true }),
        dms: zod_1.z
            .object({
            distraction: zod_1.z.enum(["OFF", "LOW", "MED", "HIGH"]).default("MED"),
            fatigue: zod_1.z.enum(["OFF", "LOW", "MED", "HIGH"]).default("MED"),
            seatbelt: zod_1.z.boolean().default(true),
            smoking: zod_1.z.boolean().default(false),
        })
            .default({
            distraction: "MED",
            fatigue: "MED",
            seatbelt: true,
            smoking: false,
        }),
        autoClipOnEvent: zod_1.z.boolean().default(true),
        autoClipLengthSec: zod_1.z
            .number()
            .int()
            .min(5)
            .max(60)
            .default(12),
        privacyMasking: zod_1.z
            .enum(["NONE", "FACE", "PLATE", "FACE_PLATE"])
            .default("FACE_PLATE"),
    })
        .default({
        adas: { threshold: "MED", enabled: true },
        dms: {
            distraction: "MED",
            fatigue: "MED",
            seatbelt: true,
            smoking: false,
        },
        autoClipOnEvent: true,
        autoClipLengthSec: 12,
        privacyMasking: "FACE_PLATE",
    }),
    controls: zod_1.z
        .object({
        remoteSnapshot: zod_1.z.boolean().default(true),
        remoteClipFetch: zod_1.z.boolean().default(true),
        channelMap: zod_1.z
            .record(zod_1.z.string(), zod_1.z.enum(["FRONT", "CABIN", "REAR", "CARGO", "OTHER"]))
            .default(() => ({})),
        commandTimeoutSec: zod_1.z
            .number()
            .int()
            .min(5)
            .max(120)
            .default(30),
        retryCount: zod_1.z
            .number()
            .int()
            .min(0)
            .max(10)
            .default(4),
    })
        .default({
        remoteSnapshot: true,
        remoteClipFetch: true,
        channelMap: {},
        commandTimeoutSec: 30,
        retryCount: 4,
    }),
    security: zod_1.z
        .object({
        playbackTokenTtlMinutes: zod_1.z
            .number()
            .int()
            .min(1)
            .max(240)
            .default(15),
        ipPinning: zod_1.z.boolean().default(false),
        mtlsDevices: zod_1.z.boolean().default(false),
        mqttAclMode: zod_1.z.enum(["TENANT", "GLOBAL"]).default("TENANT"),
        exportWatermark: zod_1.z.boolean().default(true),
    })
        .default({
        playbackTokenTtlMinutes: 15,
        ipPinning: false,
        mtlsDevices: false,
        mqttAclMode: "TENANT",
        exportWatermark: true,
    }),
    diagnostics: zod_1.z
        .object({
        heartbeatIntervalSec: zod_1.z
            .number()
            .int()
            .min(10)
            .max(300)
            .default(30),
        streamHealthWarn: zod_1.z.number().min(0).max(1).default(0.7),
        streamHealthCrit: zod_1.z.number().min(0).max(1).default(0.5),
    })
        .default({
        heartbeatIntervalSec: 30,
        streamHealthWarn: 0.7,
        streamHealthCrit: 0.5,
    }),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.aiCapabilitySchema = zod_1.z.enum([
    "chat",
    "function_calling",
    "vision",
    "streaming",
    "realtime",
    "long_context",
    "tool_use",
]);
exports.aiModelStatusSchema = zod_1.z.enum([
    "stable",
    "beta",
    "deprecated",
]);
exports.aiProviderModelSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    label: zod_1.z.string(),
    version: zod_1.z.string(),
    family: zod_1.z.string(),
    status: exports.aiModelStatusSchema.default("stable"),
    capabilities: zod_1.z.array(exports.aiCapabilitySchema).default([]),
    contextWindow: zod_1.z.number().int().positive().optional(),
    functions: zod_1.z.array(zod_1.z.string()).default([]),
})
    .strict();
exports.aiProviderConfigSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    displayName: zod_1.z.string(),
    enabled: zod_1.z.boolean().default(true),
    apiKey: zod_1.z.string().nullable().optional(),
    endpoint: zod_1.z.string().nullable().optional(),
    defaultModelId: zod_1.z.string().nullable().optional(),
    models: zod_1.z.array(exports.aiProviderModelSchema),
    features: zod_1.z.array(zod_1.z.string()).default([]),
    lastSyncedAt: zod_1.z.string().datetime().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.emailProviderSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string().nullable().optional(),
    name: zod_1.z.string(),
    type: zod_1.z.enum(["SMTP", "API"]).default("SMTP"),
    host: zod_1.z.string().nullable().optional(),
    port: zod_1.z.number().int().nullable().optional(),
    username: zod_1.z.string().nullable().optional(),
    password: zod_1.z.string().nullable().optional(),
    apiKey: zod_1.z.string().nullable().optional(),
    senderEmail: zod_1.z.string(),
    senderName: zod_1.z.string().nullable().optional(),
    rateLimit: zod_1.z.number().int().nullable().optional(),
    status: zod_1.z.enum(["active", "inactive"]).default("active"),
    isDefault: zod_1.z.boolean().default(false),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
})
    .strict();
exports.emailTemplateSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string().nullable().optional(),
    providerId: zod_1.z.string().nullable().optional(),
    name: zod_1.z.string(),
    subject: zod_1.z.string(),
    bodyHtml: zod_1.z.string(),
    bodyText: zod_1.z.string().nullable().optional(),
    variables: zod_1.z.array(zod_1.z.string()).default([]),
    category: zod_1.z.string().nullable().optional(),
    status: zod_1.z.enum(["active", "inactive"]).default("active"),
    isSystem: zod_1.z.boolean().default(false),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
})
    .strict();
exports.emailNotificationChannelSchema = zod_1.z.enum([
    "billing",
    "triggers",
    "alerts",
    "ticketing",
    "support",
    "marketing",
]);
exports.emailRoutingPolicySchema = zod_1.z
    .object({
    channel: exports.emailNotificationChannelSchema,
    enabled: zod_1.z.boolean().default(true),
    templateId: zod_1.z.string().nullable().optional(),
    cc: zod_1.z.array(zod_1.z.string()).default([]),
    bcc: zod_1.z.array(zod_1.z.string()).default([]),
    escalations: zod_1.z
        .array(zod_1.z.object({
        thresholdMinutes: zod_1.z.number().int().min(0).default(30),
        recipients: zod_1.z.array(zod_1.z.string()).default([]),
    }))
        .default([]),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
})
    .strict();
exports.emailSettingsSchema = zod_1.z
    .object({
    providers: zod_1.z.array(exports.emailProviderSchema).default([]),
    templates: zod_1.z.array(exports.emailTemplateSchema).default([]),
    defaults: zod_1.z
        .object({
        providerId: zod_1.z.string().nullable().optional(),
        templateIds: zod_1.z
            .record(exports.emailNotificationChannelSchema, zod_1.z.string().nullable())
            .default({
            alerts: null,
            billing: null,
            triggers: null,
            ticketing: null,
            support: null,
            marketing: null,
        }),
    })
        .default({
        providerId: null,
        templateIds: {
            alerts: null,
            billing: null,
            triggers: null,
            ticketing: null,
            support: null,
            marketing: null,
        },
    }),
    notifications: zod_1.z
        .object({
        policies: zod_1.z.array(exports.emailRoutingPolicySchema).default([]),
        digest: zod_1.z
            .object({
            enabled: zod_1.z.boolean().default(false),
            timezone: zod_1.z.string().default("UTC"),
            sendHour: zod_1.z.number().int().min(0).max(23).default(6),
        })
            .default({ enabled: false, timezone: "UTC", sendHour: 6 }),
    })
        .default({
        policies: [],
        digest: { enabled: false, timezone: "UTC", sendHour: 6 },
    }),
    lastSyncedAt: zod_1.z.string().nullable().optional(),
    updatedAt: zod_1.z.string().nullable().optional(),
    updatedBy: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.seoTagDefaultsSchema = zod_1.z
    .object({
    name: zod_1.z.string(),
    content: zod_1.z.string(),
})
    .strict();
exports.seoSocialSchema = zod_1.z
    .object({
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().url().optional(),
    imageAlt: zod_1.z.string().optional(),
    twitterHandle: zod_1.z.string().optional(),
    twitterCard: zod_1.z
        .enum(["summary", "summary_large_image", "app", "player"])
        .default("summary_large_image"),
})
    .strict();
exports.seoPageDefaultsSchema = zod_1.z
    .object({
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    keywords: zod_1.z.array(zod_1.z.string()).default([]),
    canonicalUrl: zod_1.z.string().url().optional(),
    noIndex: zod_1.z.boolean().default(false),
    noFollow: zod_1.z.boolean().default(false),
})
    .strict()
    .default({
    keywords: [],
    noIndex: false,
    noFollow: false,
});
exports.seoSettingsSchema = zod_1.z
    .object({
    siteTitle: zod_1.z
        .string()
        .trim()
        .default("GlonexTrack"),
    siteDescription: zod_1.z
        .string()
        .trim()
        .default("Fleet telematics and AI compliance intelligence for modern mobility operations."),
    siteKeywords: zod_1.z.array(zod_1.z.string()).default([
        "glonextrack",
        "fleet",
        "telematics",
        "gps",
        "AI",
        "insurance",
        "safety",
    ]),
    canonicalBaseUrl: zod_1.z.string().url().default("https://glonextrack.com"),
    defaultOgImageUrl: zod_1.z
        .string()
        .url()
        .default("https://glonextrack.com/assets/og-default.jpg"),
    twitterHandle: zod_1.z.string().default("@glonextrack"),
    socialDefaults: exports.seoSocialSchema.default({
        twitterCard: "summary_large_image",
    }),
    pageDefaults: zod_1.z
        .record(zod_1.z.string(), exports.seoPageDefaultsSchema)
        .default({}),
    jsonLdEnabled: zod_1.z.boolean().default(true),
    robotsEnabled: zod_1.z.boolean().default(true),
    sitemapEnabled: zod_1.z.boolean().default(true),
    robotsTxt: zod_1.z.string().default("User-agent: *\nAllow: /\nDisallow: /api\n"),
    googleSiteVerification: zod_1.z.string().nullable().optional(),
    schemaMetaTags: zod_1.z.array(exports.seoTagDefaultsSchema).default([]),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.analyticsSettingsSchema = zod_1.z
    .object({
    gaMeasurementId: zod_1.z.string().trim().optional(),
    gtmContainerId: zod_1.z.string().trim().optional(),
    fbPixelId: zod_1.z.string().trim().optional(),
    enabled: zod_1.z.boolean().default(true),
    trackPageViews: zod_1.z.boolean().default(true),
    trackFormSubmits: zod_1.z.boolean().default(true),
    trackArticleViews: zod_1.z.boolean().default(true),
    trackCustomEvents: zod_1.z.boolean().default(true),
    sendToDebugConsole: zod_1.z.boolean().default(false),
    respectDoNotTrack: zod_1.z.boolean().default(true),
    anonymizeIp: zod_1.z.boolean().default(true),
    consentModeEnabled: zod_1.z.boolean().default(true),
    consentModeDefaultState: zod_1.z
        .enum(["granted", "denied"])
        .default("denied"),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.contactRecipientSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().optional(),
    email: zod_1.z.string().email().trim(),
    primary: zod_1.z.boolean().default(false),
})
    .strict();
exports.contactSettingsSchema = zod_1.z
    .object({
    recipients: zod_1.z.array(exports.contactRecipientSchema).default([
        {
            name: "GlonexTrack Support",
            email: "info@glonextrack.com",
            primary: true,
        },
    ]),
    fromEmail: zod_1.z.string().email().default("hello@glonextrack.com"),
    fromName: zod_1.z.string().default("GlonexTrack Contact"),
    replyToEmail: zod_1.z.string().email().optional(),
    subjectTemplate: zod_1.z
        .string()
        .default("Contact form: {name} - {subject}"),
    includeSubmitterMetadata: zod_1.z.boolean().default(true),
    sendAutoReply: zod_1.z.boolean().default(false),
    autoReplySubject: zod_1.z.string().default("Thanks for contacting GlonexTrack"),
    autoReplyMessage: zod_1.z
        .string()
        .default("Thanks for reaching out. One of our team members will reply shortly."),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.blogDefaultKeywordSchema = zod_1.z
    .object({
    page: zod_1.z.string(),
    keywords: zod_1.z.array(zod_1.z.string()).default([]),
})
    .strict();
exports.blogDefaultsSchema = zod_1.z
    .object({
    defaultCategoryId: zod_1.z.string().optional(),
    defaultTags: zod_1.z.array(zod_1.z.string()).default([]),
    defaultAuthorName: zod_1.z.string().optional(),
    defaultAuthorRole: zod_1.z.string().optional(),
    defaultFeatureImage: zod_1.z.string().url().optional(),
    defaultAdWidgetHtml: zod_1.z.string().optional(),
    defaultSeoKeywordBundles: zod_1.z.array(exports.blogDefaultKeywordSchema).default([]),
    aiAuthorCreditPrefix: zod_1.z.string().default("AI"),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.aiSettingsSchema = zod_1.z
    .object({
    defaultProviderId: zod_1.z.string(),
    providers: zod_1.z.array(exports.aiProviderConfigSchema),
    updatedAt: zod_1.z.string().datetime(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.favouritePoiSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    address: zod_1.z.string().optional(),
    location: zod_1.z.object({ lat: zod_1.z.number(), lng: zod_1.z.number() }),
    type: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().datetime(),
    createdBy: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .strict();
exports.routingSettingsSchema = zod_1.z
    .object({
    trafficModel: zod_1.z
        .enum(["best_guess", "pessimistic", "optimistic"])
        .default("best_guess"),
    defaultDepartureOffsetMinutes: zod_1.z.number().int().min(0).default(0),
    avoidTolls: zod_1.z.boolean().default(false),
    avoidHighways: zod_1.z.boolean().default(false),
    avoidFerries: zod_1.z.boolean().default(false),
    useRoutesApi: zod_1.z.boolean().default(false),
    routingPreference: zod_1.z
        .enum(["TRAFFIC_AWARE", "TRAFFIC_AWARE_OPTIMAL", "TRAFFIC_UNAWARE"])
        .default("TRAFFIC_AWARE_OPTIMAL"),
    assignBy: zod_1.z.enum(["tenant", "vehicle", "user"]).default("tenant"),
    assignedVehicles: zod_1.z.array(zod_1.z.string()).default([]),
    assignedUsers: zod_1.z.array(zod_1.z.string()).default([]),
    mapMatchingEnabled: zod_1.z.boolean().default(true),
    interpolation: zod_1.z.boolean().default(true),
    favouritePois: zod_1.z.array(exports.favouritePoiSchema).default([]),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.fleetSettingsSchema = zod_1.z
    .object({
    maintenanceAlertThresholdDays: zod_1.z.number().int().min(0).max(365).default(14),
    showTelemetryToDrivers: zod_1.z.boolean().default(true),
    autoAssignRoutes: zod_1.z.boolean().default(false),
    preferredNavigationProvider: zod_1.z.enum(["google", "here", "mapbox"]).default("google"),
    allowDriverSelfDispatch: zod_1.z.boolean().default(false),
    updatedAt: zod_1.z.string().datetime().optional(),
    updatedBy: zod_1.z.string().optional(),
})
    .strict();
exports.cmsSectionIds = [
    "hero",
    "showcase",
    "features",
    "testimonials",
    "services",
    "about",
    "ctaBanner",
    "footer",
];
exports.cmsLinkSchema = zod_1.z
    .object({
    label: zod_1.z.string(),
    href: zod_1.z.string(),
})
    .strict();
exports.cmsStatSchema = zod_1.z
    .object({
    label: zod_1.z.string(),
    value: zod_1.z.string(),
})
    .strict();
exports.cmsFeatureSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    icon: zod_1.z.string(),
})
    .strict();
exports.cmsTestimonialSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    quote: zod_1.z.string(),
    name: zod_1.z.string(),
    role: zod_1.z.string(),
    avatar: zod_1.z.string().optional(),
})
    .strict();
exports.cmsServiceSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    bulletPoints: zod_1.z.array(zod_1.z.string()),
})
    .strict();
exports.cmsTimelineEntrySchema = zod_1.z
    .object({
    year: zod_1.z.number(),
    milestone: zod_1.z.string(),
})
    .strict();
exports.cmsValueSchema = zod_1.z
    .object({
    title: zod_1.z.string(),
    description: zod_1.z.string(),
})
    .strict();
exports.cmsHeroSchema = zod_1.z
    .object({
    headline: zod_1.z.string(),
    subheadline: zod_1.z.string(),
    ctaPrimary: exports.cmsLinkSchema,
    ctaSecondary: exports.cmsLinkSchema.optional(),
    media: zod_1.z
        .object({
        type: zod_1.z.enum(["image", "video"]),
        src: zod_1.z.string(),
        poster: zod_1.z.string().optional(),
    })
        .strict(),
})
    .strict();
exports.cmsAboutSchema = zod_1.z
    .object({
    mission: zod_1.z.string(),
    timeline: zod_1.z.array(exports.cmsTimelineEntrySchema),
    values: zod_1.z.array(exports.cmsValueSchema),
})
    .strict();
exports.cmsCtaBannerSchema = zod_1.z
    .object({
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    cta: exports.cmsLinkSchema,
})
    .strict();
exports.cmsFooterSchema = zod_1.z
    .object({
    address: zod_1.z.string(),
    email: zod_1.z.string(),
    phone: zod_1.z.string(),
    socials: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string(),
        label: zod_1.z.string(),
        href: zod_1.z.string(),
    })
        .strict()),
})
    .strict();
exports.cmsShowcaseSchema = zod_1.z
    .object({
    stats: zod_1.z.array(exports.cmsStatSchema),
})
    .strict();
exports.cmsSettingsSchema = zod_1.z
    .object({
    hero: exports.cmsHeroSchema,
    showcase: exports.cmsShowcaseSchema,
    features: zod_1.z.array(exports.cmsFeatureSchema),
    testimonials: zod_1.z.array(exports.cmsTestimonialSchema),
    services: zod_1.z.array(exports.cmsServiceSchema),
    about: exports.cmsAboutSchema,
    ctaBanner: exports.cmsCtaBannerSchema,
    footer: exports.cmsFooterSchema,
})
    .strict();
exports.aiProviderCatalogSchema = zod_1.z
    .object({
    providers: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string(),
        display_name: zod_1.z.string(),
        endpoint: zod_1.z.string().nullable().optional(),
        features: zod_1.z.array(zod_1.z.string()).default([]),
        models: zod_1.z.array(exports.aiProviderModelSchema),
    })
        .strict()),
    generatedAt: zod_1.z.string().datetime(),
})
    .strict();
